import { render, staticRenderFns } from "./PartnerSettings.vue?vue&type=template&id=4b1d4f1a&scoped=true"
import script from "./PartnerSettings.vue?vue&type=script&lang=ts"
export * from "./PartnerSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d4f1a",
  null
  
)

export default component.exports